const initialState = {
  techSupportActiveTab: '2',
};

// eslint-disable-next-line default-param-last
const customerService = (state = initialState, action) => {
  let nstate = {};

  switch (action.type) {
    case 'UPDATE_TECH_SUPPORT_ACTIVE_TAB':
      nstate = {
        ...state,
        techSupportActiveTab: action.payload,
      };
      break;
    default:
      nstate = state;
  }

  return nstate;
};

export default customerService;
